'use client';

import '@ui5/webcomponents/dist/Tab.js';
import { SemanticColor } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `Tab` represents a selectable item inside a `Tabcontainer`. It defines both the item in the tab strip (top part of the `Tabcontainer`) and the content that is presented to the user once the tab is selected
 *
 * @abstract
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-TabContainer)
 */
const Tab = withWebComponent('ui5-tab', ['additionalText', 'design', 'icon', 'text'], ['disabled', 'selected'], ['subTabs'], []);
Tab.displayName = 'Tab';
Tab.defaultProps = {
  design: SemanticColor.Default
};
export { Tab };